export const FETCH_TRIGGER = 'FETCH_TRIGGER';

export const setFetchTriggerCall = (fetchTriggerCall) => ({
  type: FETCH_TRIGGER,
  payload: fetchTriggerCall,
});
